// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__14uVS","selects":"Documents_selects__1qb6-"};